import { render, staticRenderFns } from "./productnewlist.vue?vue&type=template&id=779c1cb4&scoped=true"
import script from "./productnewlist.vue?vue&type=script&lang=js"
export * from "./productnewlist.vue?vue&type=script&lang=js"
import style0 from "./productnewlist.vue?vue&type=style&index=0&id=779c1cb4&prod&scoped=true&lang=css"
import style1 from "./productnewlist.vue?vue&type=style&index=1&id=779c1cb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779c1cb4",
  null
  
)

export default component.exports